import { Tag, TagType, AllAvailableTags } from '../../domain';
import { PROGRAM_AREAS } from './PROGRAM_AREAS';

export const PROGRAM_AREA_TAGS = 
	sortedByName(
		PROGRAM_AREAS.map(pa =>
			new Tag(TagType.ProgramArea, pa.id, pa.name)));

export const STRATEGIC_INITIATIVE_TAGS = sortedByName([
    new Tag(TagType.StrategicInitiative, 1, "Healthy Food Systems"),
    new Tag(TagType.StrategicInitiative, 2, "Sustainable Natural Ecosystems"),
    new Tag(TagType.StrategicInitiative, 3, "Healthy Families and Communities"),
    new Tag(TagType.StrategicInitiative, 4, "Water Quality, Quantity, and Security"),
    new Tag(TagType.StrategicInitiative, 5, "Endemic and Invasive Pests and Diseases")
]);

export const USER_DEFINED_TAGS = sortedByName([
    new Tag(TagType.UserDefined, 1, "#SaveTheWater"),
    new Tag(TagType.UserDefined, 2, "For Jerry"),
    new Tag(TagType.UserDefined, 3, "My-Rice"),
    new Tag(TagType.UserDefined, 4, "MyPriorities"),
    new Tag(TagType.UserDefined, 5, "Statewide Conference"),
]);

export const STATEWIDE_TAGS = sortedByName([
	new Tag(TagType.Statewide, 2, "Youth, Families, and Communities Statewide Program"),
	new Tag(TagType.Statewide, 7, "Agricultural Issues Center"),
	new Tag(TagType.Statewide, 24, "California 4-H Foundation"),
	new Tag(TagType.Statewide, 50, "Expanded Food Nutrition Education Program (EFNEP)"),
	new Tag(TagType.Statewide, 69, "Integrated Pest Management (IPM) Statewide Program"),
	new Tag(TagType.Statewide, 151, "Sustainable Agricultural Research & Education Program"),
	new Tag(TagType.Statewide, 187, "UC Master Gardener Program"),
	new Tag(TagType.Statewide, 240, "Informatics and GIS (IGIS) Statewide Program"),
	new Tag(TagType.Statewide, 243, "California Institute for Water Resources"),
	new Tag(TagType.Statewide, 244, "California Naturalist Program"),
	new Tag(TagType.Statewide, 246, "Nutrition Policy Institute"),
	new Tag(TagType.Statewide, 252, "UC Master Food Preserver Program")
])

export const CONDITION_CHANGE_TAGS = sortedByName([
	new Tag(TagType.ConditionChange, 1, "Improved workforce development for individuals, communities, and industry"),
	new Tag(TagType.ConditionChange, 2, "Improved built environment, landscaping, and access to green spaces"),
	new Tag(TagType.ConditionChange, 3, "Improved living and working conditions"),
	new Tag(TagType.ConditionChange, 4, "Increased equitable access to resources (e.g., information, education, technology, services, land, capital, clean air and water, healthcare)"),
	new Tag(TagType.ConditionChange, 5, "Enhanced business and community leadership"),
	new Tag(TagType.ConditionChange, 6, "Improved readiness and access to post-secondary education and career opportunities"),
	new Tag(TagType.ConditionChange, 7, "Reduced drivers to climate change"),
	new Tag(TagType.ConditionChange, 8, "Increased preparedness and resilience to climate change"),
	new Tag(TagType.ConditionChange, 9, "Improved mental and physical well-being across an individuals lifespan"),
	new Tag(TagType.ConditionChange, 10, "Improved community health and wellness"),
	new Tag(TagType.ConditionChange, 11, "Enhanced community and economic development"),
	new Tag(TagType.ConditionChange, 12, "Improved food and nutrition security, food sovereignty, and access to culturally relevant foods"),
	new Tag(TagType.ConditionChange, 13, "Improved air quality"),
	new Tag(TagType.ConditionChange, 14, "Improved land stewardship (e.g., equitable land access, land use planning, restoration, and management strategies)"),
	new Tag(TagType.ConditionChange, 15, "Improved mgmt. and use of water resources"),
	new Tag(TagType.ConditionChange, 16, "Improved soil health and productivity"),
	new Tag(TagType.ConditionChange, 17, "Improved animal management (e.g., welfare, profitability, and sustainability)"),
	new Tag(TagType.ConditionChange, 18, "Increased ecological sustainability of agriculture, working landscapes, and natural ecosystems"),
	new Tag(TagType.ConditionChange, 19, "Increased stability, efficiency, and profitability of agriculture and working landscapes"),
	new Tag(TagType.ConditionChange, 20, "Enhanced food systems and markets (e.g., crops/products, supply chains, diversified/niche markets)"),
	new Tag(TagType.ConditionChange, 21, "Improved water quality"),
	new Tag(TagType.ConditionChange, 22, "Improved water use efficiency and water supply security"),
	new Tag(TagType.ConditionChange, 23, "Improved water-supply security", true),
	new Tag(TagType.ConditionChange, 24, "Increased preparedness and resilience to extreme weather and climate change", true),
	new Tag(TagType.ConditionChange, 25, "Increased community disaster preparedness and resilience to extreme weather and change in climate"),
	new Tag(TagType.ConditionChange, 26, "Increased ecosystem resilience to extreme weather and change in climate"),
	new Tag(TagType.ConditionChange, 27, "Increased agriculture and food system resilience to extreme weather and change in climate"),
	new Tag(TagType.ConditionChange, 28, "Increased carbon sequestration and mitigation of greenhouse gas emissions"),
	new Tag(TagType.ConditionChange, 29, "Enhanced waste reduction, recovery, and economic reuse"),
	new Tag(TagType.ConditionChange, 30, "Reduced reliance on fossil fuels"),
	new Tag(TagType.ConditionChange, 31, "Improved biodiversity (e.g. protected, restored)"),
	new Tag(TagType.ConditionChange, 32, "Increased public engagement and confidence in science"),
	new Tag(TagType.ConditionChange, 33, "Enhanced regional-based food supply chains"),
])

export const OUTCOME_TYPE_TAGS = sortedByName([
	new Tag(TagType.OutcomeType, 1, "Change in Learning"),
	new Tag(TagType.UserDefined, 2, "Change in Action"),
	new Tag(TagType.UserDefined, 3, "Change in Policy or Decision-Making"),
	new Tag(TagType.UserDefined, 4, "Change in Condition"),
]);
export const RESEARCH_EXTENSION_TAGS = sortedByName([
    new Tag(TagType.ResearchExtension, 1, "Desert"),
    new Tag(TagType.ResearchExtension, 2, "Hansen"),
    new Tag(TagType.ResearchExtension, 3, "Hopland"),
    new Tag(TagType.ResearchExtension, 4, "Intermountain"),
    new Tag(TagType.ResearchExtension, 5, "Kearney"),
	new Tag(TagType.ResearchExtension, 6, "Lindcove"),
    new Tag(TagType.ResearchExtension, 7, "Sierra Foothills"),
    new Tag(TagType.ResearchExtension, 8, "South Coast"),
    new Tag(TagType.ResearchExtension, 9, "Westside"),
    new Tag(TagType.ResearchExtension, 10, "REC System")
]);


export const ALL_AVAILABLE_TAGS: AllAvailableTags =
	new AllAvailableTags(
		[],
		STRATEGIC_INITIATIVE_TAGS,
		USER_DEFINED_TAGS,
		STATEWIDE_TAGS,
		CONDITION_CHANGE_TAGS,
		RESEARCH_EXTENSION_TAGS,
		PROGRAM_AREA_TAGS,
		OUTCOME_TYPE_TAGS);

export const TAGS: Tag[] =
	Array.prototype.concat.apply([], [
		STRATEGIC_INITIATIVE_TAGS,
		USER_DEFINED_TAGS,
		STATEWIDE_TAGS,
		CONDITION_CHANGE_TAGS,
		PROGRAM_AREA_TAGS,
		OUTCOME_TYPE_TAGS]);

function sortedByName(tags: Tag[]): Tag[] {
	tags.sort((a,b) => 
		a.name < b.name 
			? 1 
			: b.name < a.name 
			? -1 
			: 0);
	return tags;
}
